module.exports = __webpack_public_path__ + "assets/svg/Icons/32/shift-white-a4a7ba.svg";